// extracted by mini-css-extract-plugin
export var changeIcon = "_6d-4";
export var container = "_6d-0";
export var divider = "_6d-7";
export var externalLinkIcon = "_6d-1";
export var green = "_6d-5";
export var helpCircleIcon = "_6d-3";
export var iconButton = "_6d-2";
export var red = "_6d-6";